import React, { useContext, useEffect } from 'react';
import withContentfulTag from '../../utils/withContentfulTag';
import { contentfulPropTypes } from '../../propTypes';
import ReactMarkdown from 'react-markdown';
import { Button, Spinner } from 'react-bootstrap';
import { ConsentContext, ConsentFlows } from '../../context/ConsentContext';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

const ReconfirmSuccessContainer = ({ contentful, loading, fetched }) => {
  const {
    isSaving,
    setIsSaving,
    setHasRegisterMpanTrustedConsent,
    setHasOnboarded,
  } = useContext(ConsentContext);

  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      await recordFlowProgress(
        flowSteps.RECONFIRM_CONFIRMATION,
        ConsentFlows.RECONFIRM,
      );
    };
    asyncRecordFlowProgress();
  }, []);

  useEffect(() => {
    setHasRegisterMpanTrustedConsent(false);
    setHasOnboarded(true);
    setIsSaving(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    !loading &&
    fetched && (
      <div className="text-center">
        <h1 className="mb-3">{contentful?.title}</h1>
        <ReactMarkdown>{contentful?.body}</ReactMarkdown>
        {isSaving ? (
          <Spinner animation="border" />
        ) : (
          <>
            {contentful?.primaryButtonText && (
              <Button href="/account" variant="secondary" className="mt-2 px-4">
                {contentful.primaryButtonText}
              </Button>
            )}
          </>
        )}
      </div>
    )
  );
};

ReconfirmSuccessContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  ReconfirmSuccessContainer,
  'web_app_reconsent_success_page',
);
